import styled from 'styled-components'

import { useLocalStorage } from '@scouts/helpers'
import { colors, font, radius, shadows, ButtonLink, Container, Flexer, Line, Paragraph, Spacer } from '@scouts/ui'

import EurosLogo from '@/assets/images/0euros.png'

import { BankingPromotionLink } from './BankingPromotionLink'

export const BankingPromotionBanner = () => {
    const [shouldHide, setShouldHide] = useLocalStorage('hide_bbva_promotion', false)

    if (shouldHide) return null

    const handleHide = () => {
        setShouldHide(true)
    }

    return (
        <Container padding="18px" shadow={shadows.low} background={colors.surface.highlight} radius={radius.large}>
            <Flexer gap="12px" alignCenter>
                <Img src={EurosLogo} alt="Logo Cuenta BBVA" />
                <Container>
                    <Spacer marginBottom="12px">
                        <Flexer spaceBetween>
                            <Line weight={font.weight.medium} size={font.small}>
                                ¿Una cuenta para separar tu vida profesional de la personal?
                            </Line>
                            <ButtonLink onClick={handleHide}>Ocultar</ButtonLink>
                        </Flexer>
                    </Spacer>
                    <Paragraph size={font.small}>
                        ¡En BBVA es posible! Abre una Cuenta Negocios Bienvenida para autónomos y disfruta de todas sus
                        ventajas que harán más fácil tu día a día.{' '}
                        <BankingPromotionLink>Hazte cliente</BankingPromotionLink>.
                    </Paragraph>
                </Container>
            </Flexer>
        </Container>
    )
}

const Img = styled.img`
    width: 60px;
    pointer-events: none;
`
